import { render, staticRenderFns } from "./receiving.vue?vue&type=template&id=4f751d32"
import script from "./receiving.vue?vue&type=script&lang=js"
export * from "./receiving.vue?vue&type=script&lang=js"
import style0 from "./receiving.vue?vue&type=style&index=0&id=4f751d32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports